export const BTN_TIMING = 0.5;
